import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrashAlt,
  faCircleDot,
  faCircle,
  faAddressBook,
} from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import ContactForm from "./ContactForm";
import Swal from "sweetalert2";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import Title from "../../../components/ui/Title";
import PopoverMenu from "../../../components/ui/PopoverMenu";

function ContactsList({ partner, setPartner }) {
  const [modalContactFormIsOpen, setModalContactFormIsOpen] = useState(false);
  const [partnerContactSelected, setPartnerContactSelected] = useState();
  const { t } = useTranslation();

  const handleDeleteContact = (pc) => {
    Swal.fire({
      text:
        t("global.form.delete") + " " + pc.firstName + " " + pc.lastName + " ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axiosConfig
          .delete(process.env.REACT_APP_API_URL + pc["@id"])
          .then((response) => {
            if (response?.status === 204) {
              toast.success(t("partnerContact.deleted"), {
                theme: "colored",
                hideProgressBar: true,
              });

              let newPartnerContacts = partner.partnerContacts.filter(
                (p) => p.id !== pc.id
              );
              setPartner({ ...partner, partnerContacts: newPartnerContacts });
            } else {
              if (
                e.response?.status !== 200 &&
                e.response?.data["hydra:description"]
              ) {
                toast.success(t("partnerContact.deleted"), {
                  theme: "colored",
                  hideProgressBar: true,
                });
              }
            }
          })
          .catch((e) => {
            toast.error(e.response.data["hydra:description"], {
              theme: "colored",
              hideProgressBar: true,
            });
          });
      }
    });
  };

  const toggleMainContact = async (pc) => {
    await axiosConfig
      .patch(
        process.env.REACT_APP_API_URL + pc["@id"],
        { main: true },
        {
          headers: { "Content-Type": "application/merge-patch+json" },
        }
      )
      .then((response) => {
        if (response?.status === 200 && response?.data) {
          let newPartnerContacts = partner.partnerContacts.map((pc) =>
            pc.id === response.data.id ? response.data : { ...pc, main: false }
          );
          setPartner({ ...partner, partnerContacts: newPartnerContacts });
        }
      });
  };

  const openModalContact = async (pc = null) => {
    setPartnerContactSelected(pc);
    setModalContactFormIsOpen(true);
  };

  const closeModalContact = () => {
    setModalContactFormIsOpen(false);
  };

  useEffect(() => {
    if (modalContactFormIsOpen === false) {
      setPartnerContactSelected(null);
    }
  }, [partnerContactSelected]);

  return (
    <div>
      <div className="lg:p-8 lg:px-10 mt-8 lg:bg-white rounded-lg">
        <Title
          icon={faAddressBook}
          title={"contacts"}
          button={{
            label: t('partnerContact.create'),
            fn: () => openModalContact(null),
          }}
        />

        <div className="bg-bioport-blue-light grid grid-cols-12 text-white font-bold px-4 p-3">
          <div className="col-span-5">
            {t("user.firstName")} / {t("user.lastName")}
          </div>
          <div className="col-span-2 text-center">{t("user.phoneNumber")}</div>
          <div className="col-span-2 text-center">{t("login.email")}</div>
          <div className="col-span-2 text-center">
            {t("partnerContact.main")}
          </div>
          <div className="col-span-1 text-center"></div>
        </div>
        {partner.partnerContacts.map((pc, key) => (
          <div
            key={key}
            className={`grid grid-cols-12 px-4 p-3 hover:bg-gray-50 ${
              key % 2 === 0 && "bg-gray-100"
            }`}
          >
            <div className="col-span-5">
              {pc.firstName} {pc.lastName}
            </div>
            <div className="col-span-2 text-center">{pc.phoneNumber}</div>
            <div className="col-span-2 text-center">
              <a href={`mailto:${pc.email}`} className="hover:underline">
                {pc.email}
              </a>
            </div>
            <div className="col-span-2 text-center">
              <FontAwesomeIcon
                icon={pc.main ? faCircleDot : faCircle}
                className="hover:scale-110 cursor-pointer"
                onClick={() => toggleMainContact(pc)}
              />
            </div>
            <div className="col-span-1 text-center">
              <PopoverMenu
                links={[
                  {
                    link: () => openModalContact(pc),
                    icon: faEdit,
                    label: t("global.edit"),
                    class:
                      "hover:cursor-pointer hover:underline text-bioport-blue mb-2",
                  },
                  {
                    link: () => handleDeleteContact(pc),
                    icon: faTrashAlt,
                    label: t("global.form.delete"),
                    class: "hover:cursor-pointer hover:underline text-red-600",
                  },
                ]}
              />
            </div>
          </div>
        ))}
      </div>
      <ContactForm
        setIsOpen={setModalContactFormIsOpen}
        modalIsOpen={modalContactFormIsOpen}
        partnerContactSelected={partnerContactSelected}
        partner={partner}
        setPartner={setPartner}
        closeModal={closeModalContact}
      />
    </div>
  );
}

export default ContactsList;
